<div class="d-inline-flex mb-4">
  <a
    routerLink="{{ link.link }}"
    class="routing_tab_item"
    routerLinkActive="is-active"
    *ngFor="let link of links"
    >{{ link.title }}</a
  >
</div>
